module.exports = __webpack_public_path__ + "img/test_four3.f4174295.png";